import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const GoToSource = ({sample}) => { 
    const goToSource = useCallback(() => {
        if (sample.videoId) {
            window.open('https://youtube.com/watch?v=' + sample.videoId, '_blank');
        } else if (sample.discogsId) {
            window.open('https://discogs.com/release/' + sample.discogsId, '_blank');
        }
    }, [sample]);

    return (
        <div className="go-to-source">
          <span onClick={goToSource}>Go to source</span>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GoToSource);
